import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthProvider';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-foreground"></div>
      </div>
    );
  }

  if (!user) {
    // Come back here after login (e.g. "Send to customer" from a Gorgias note).
    try { sessionStorage.setItem('replai.returnTo', location.pathname + location.search); } catch { /* storage blocked */ }
    return <Navigate to="/login" replace />;
  }
  return children;
};

export const afterLogin = () => {
  try {
    const to = sessionStorage.getItem('replai.returnTo');
    sessionStorage.removeItem('replai.returnTo');
    if (to && to.startsWith('/') && !to.startsWith('/login')) return to;
  } catch { /* storage blocked */ }
  return '/dashboard';
};

export default PrivateRoute;
